/// ----------------------------------------------------------------------------------------
///Copyright (C) 2016 to the present, Crestron Electronics, Inc.
///All rights reserved.
///No part of this software may be reproduced in any form, machine
///or natural, without the express written consent of Crestron Electronics. 
/// ----------------------------------------------------------------------------------------
/// <file>
/// <name>device-control.model.ts</name>
///
/// <description>
///  
/// </description>
///
/// <author>Michael Martinez</author>
/// <created>30 Aug 2016</created>
///
/// <changelog>
///   Date  Who Version     Flag Comments
/// ======= === =========== ==== ===========================================================
/// 30Aug16 MM  1.0.0000         First cut
/// </changelog>
///
/// </file>
/// ----------------------------------------------------------------------------------------
export enum DeviceControlType {
    Button = 0,
    ButtonCrud = 1,
    CheckBox = 2,
    CheckBoxList = 3,
    ComboBox = 4,
    Default = 5,
    DialogBox = 6,
    FileUpload = 7,
    Grid = 8,
    InputSwitch = 9,
    Password = 10,
    RadioButton = 11,
    TextBox = 12,
    Time = 13
}


// WEBPACK FOOTER //
// C:/WS/Fusion/FusionDashboard/src/app/models/device-data-models/device-control-type.model.ts